import React, {useEffect} from 'react';
import {BrowserRouter, HashRouter, Route, Switch} from 'react-router-dom';
import './scss/style.scss';
import 'react-datepicker/dist/react-datepicker.min.css'
import {registerLocale} from "react-datepicker";
import en from "date-fns/locale/en-US";
import {TopMessage} from "./helpers/HtmlComponentsHelper/HtmlComponentsHelper";
import {useSelector} from "react-redux";
import BranchLocation from "./components/BranchLocation/BranchLocation"; // the locale you want
import {
    getCredential,
    getUserId,
    removeCredential,
    removeStorage,
    removeStorageAndLogout,
    setCredentials
} from './helpers/CommonHelper';
import {func} from "prop-types";
import axios from "axios";
import api from "./services/baseapi";

registerLocale("en", en);

const loading = (
    <div className="pt-3 text-center">
        <div className="sk-spinner sk-spinner-pulse"></div>
    </div>
)

const Login = React.lazy(() => import('./components/Login/Login'));
const Signup = React.lazy(() => import('./components/Signup/Signup'));
const SigninAfterApproval = React.lazy(() => import('./components/Signup/SigninAfterApproval'))
const TheLayout = React.lazy(() => import('./components/containers/TheLayout'));
const FAQ = React.lazy(() => import('./components/StaticPages/FAQ'));
const PrivacyPolicy = React.lazy(() => import('./components/StaticPages/PrivacyPolicy'));
const SafetyInstruction = React.lazy(() => import('./components/StaticPages/SafetyInstruction'));
const RegisterManual = React.lazy(() => import('./components/StaticPages/RegisterManual'));
const About = React.lazy(() => import('./components/StaticPages/About'));
const ContactUs = React.lazy(() => import('./components/StaticPages/ContactUs'));
const ForgotPassword = React.lazy(() => import('./components/ForgotPassword/ForgotPassword'));
const ForgotPinAndPassword = React.lazy(() => import('./components/ForgotPassword/ForgotPinAndPassword'));

function App() {

    const topMessage = useSelector(state => state.messages?.payload?.server)

    window.addEventListener("popstate", (event) => {
        if (getUserId() && event.currentTarget.location.href.includes("/login")) {
            if (window.confirm("Do you want to log out?")) {
                removeCredential();
            } else {
                window.history.pushState(null, null, "/dashboard");
                // window.history.back();
            }
        }
    });


    const AUTO_LOGOUT_TIME = sessionStorage.getItem("_expiredTime") ? parseInt(sessionStorage.getItem("_expiredTime")) : 60 * 1000; //default 1 minutes
    function resetTimer() {
        sessionStorage.setItem("_idleTimeoutTimer", (new Date().getTime() + AUTO_LOGOUT_TIME).toString());
    }

    window.onload = resetTimer;
    window.onmousemove = resetTimer;
    window.onmousedown = resetTimer;
    window.ontouchstart = resetTimer;
    window.onkeydown = resetTimer;
    window.addEventListener('scroll', resetTimer, true);


    const updatedHash = "e1a5a5ac4b9d9612d205f9f768f75012c35c4971";
    const localStorageHash = localStorage.getItem("ib-ui-hash");

    if (updatedHash !== localStorageHash){
        localStorage.setItem("ib-ui-hash", updatedHash);
        window.location.reload();
    }

    const logout = () => {
        api.get("/api/users/logout")
            .then(res => {
                removeStorageAndLogout();
            })
            .catch(ex => {
                removeStorageAndLogout();
            });
    }

    async function check() {


        let credentials = getCredential();
        try {

            if (credentials && credentials.isPasswordChangeRequired && credentials.isPasswordChangeRequired === true){
               if(!window.location.href.includes("change-password"))
                   window.location.href = "/change-password";
            }

            if (credentials && credentials.refreshToken && credentials.sessionExpiredTimeInMillis) {

                const idleTime = sessionStorage.getItem("_idleTimeoutTimer") ? parseInt(sessionStorage.getItem("_idleTimeoutTimer")) : 0

                console.log("checking time is over : " + new Date(idleTime));

                if (new Date().getTime() > idleTime) logout();
                else if (new Date().getTime() > (idleTime - 15000)) {

                    await api.get("/api/users/refresh-access-token").then(r => {
                        if (r && r.data && r.data.sessionExpiredTimeInMillis && r.data.accessToken && r.data.refreshToken) {
                            credentials.sessionExpiredTimeInMillis = r.data.sessionExpiredTimeInMillis;
                            credentials.token = r.data.accessToken;
                            credentials.refreshToken = r.data.refreshToken;
                            setCredentials(credentials);
                            console.log("refresh token update done");
                        }
                    }).catch(error => {
                        logout();
                    });
                }

            }
        } catch (e) {
            logout();
        }

    }

    useEffect(() => {
            check()
        },
        []);

    setInterval(check, 10000);


    return (
        <BrowserRouter>
            {topMessage.message && TopMessage(topMessage)}
            <React.Suspense fallback={loading}>
                <Switch>
                    {/*<Route exact path="/login" name="Login Page" render={props => <Login {...props}/>} />*/}
                    <Route path="/faq" render={props => <FAQ {...props} />}/>
                    <Route path="/privacy-policy" render={props => <PrivacyPolicy {...props} />}/>
                    <Route path="/safety-instruction" render={props => <SafetyInstruction {...props} />}/>
                    <Route path="/register-manual" render={props => <RegisterManual {...props} />}/>
                    <Route path="/about" render={props => <About {...props} />}/>
                    <Route path="/contact-us" render={props => <ContactUs {...props} />}/>
                    <Route path="/atm-location" render={props => <BranchLocation {...props} locationType={"ATM"}/>}/>
                    <Route path="/branch-location"
                           render={props => <BranchLocation {...props} locationType={"Branch"}/>}/>
                    <Route path="/login" render={props => <Login {...props} />}/>
                    <Route path="/signup" render={props => <Signup {...props} />}/>
                    <Route path="/forgot-password" render={props => <ForgotPassword {...props} />}/>
                    <Route path="/forgot-pin-and-password" render={props => <ForgotPinAndPassword {...props}/>}/>
                    <Route path="/users/access-link" render={props => <SigninAfterApproval {...props}/>}/>
                    <Route path="/" render={props => <TheLayout {...props} />}/>
                </Switch>
            </React.Suspense>
        </BrowserRouter>
    );
}

export default App;
